export default __webpack_public_path__ + "static/media/NanumSquareOTF_acR.f257b793.otf";